/*
	params:
		API
*/

var ko = require('knockout'),
  APIHelper = require('_js/APIHelper'),
  decodeHtml = require('_utils/text');

function AddEmployeeModal(params) {
  var self = this;
  self.params = params;
  self.API = self.params.api;
  self.parent = self.params.parent;
  self.agencyAktorId = self.params.agencyaktorid;

  self.activeModal = ko.observable(true);
  self.hasSearched = ko.observable(false);
  self.isSearching = ko.observable(false);
  self.isSubmitting = ko.observable(false);
  self.registerNewUser = ko.observable(false);
  self.showErrorMessage = ko.observable(false);
  self.hasUpdatedSuccessfully = ko.observable(false);
  self.isExistingUserMember = ko.observable(false);
  self.errorText = ko.observable('');
  self.successText = ko.observable('');
  self.modalUsers = ko.observable(0);
  self.results = ko.observableArray([]);
  self.resultOption = ko.observable(0);

  self.searchPerson = function() {
    var url =
      self.API.getPersonById +
      '?aktorId=' +
      encodeURIComponent(self.searchQuery());
    APIHelper.get(
      url,
      function(data) {
        self.hasSearched(true);
        self.results(data);
      },
      function(response) {
        var location = window.location.href || document.URL;
        APIHelper.post('/api/log/error', {
          message: 'API-error: add-employee-modal.js',
          context: location,
          parameters: [
            'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
            'platform: ' + navigator.platform,
            'responseText: ' + response.responseText,
            'status: ' + response.status,
            'statusText: ' + response.statusText,
            'requestUrl: ' + url
          ]
        });
      }
    );
  };

  self.searchMobileNumber = ko.observable().extend({
    required: [
      {
        type: 'isOptional',
        message: 'Feltet må samsvare med det vanlige uttrykket [0-9](8)'
      },
      {
        type: 'isNumber',
        message: 'Feltet må samsvare med det vanlige uttrykket [0-9](8)'
      },
      {
        type: 'isLength',
        length: 8,
        message: 'Feltet må samsvare med det vanlige uttrykket [0-9](8)'
      }
    ]
  });

  self.searchMobileNumber.subscribe(function(val) {
    self.mobileNumber(val);
  });

  self.searchEmail = ko.observable().extend({
    required: [
      { type: 'isOptional', message: 'optional' },
      { type: 'isEmail', message: 'Feltet må være en gyldig epostadresse' }
    ]
  });

  self.searchEmail.subscribe(function(val) {
    self.email(val);
  });

  self.givenName = ko.observable().extend({
    required: [{ type: 'isNotEmpty', message: 'Feltet kan ikke være tomt' }]
  });

  self.surname = ko.observable().extend({
    required: [{ type: 'isNotEmpty', message: 'Feltet kan ikke være tomt' }]
  });

  self.mobileNumber = ko.observable().extend({
    required: [
      {
        type: 'isNumber',
        message: 'Feltet må samsvare med det vanlige uttrykket [0-9](8)'
      },
      {
        type: 'isLength',
        length: 8,
        message: 'Feltet må samsvare med det vanlige uttrykket [0-9](8)'
      }
    ]
  });

  self.email = ko.observable().extend({
    required: [
      { type: 'isEmail', message: 'Feltet må være en gyldig epostadresse' }
    ]
  });
}

AddEmployeeModal.prototype.init = function(element) {
  this.element = element;
  this.modalEl = this.element.querySelector('.modal');
};

AddEmployeeModal.prototype.validateForm = function() {
  this.reset();
  this.isSearching(true);

  // Check if user already exists.
  this.checkIfExistingUser();
};

AddEmployeeModal.prototype.checkIfExistingUser = function() {
  var self = this;
  var url =
    self.API.personExistsUrl +
    '?phoneNumber=' +
    encodeURIComponent(self.searchMobileNumber()) +
    '&email=' +
    encodeURIComponent(self.searchEmail());

  APIHelper.get(
    url,
    function(data) {
      self.hasSearched(true);
      self.results(data);
      self.isSearching(false);
      if (data.length > 0) {
        self.isExistingUserMember(true);
        self.modalEl.scrollTop = 500;
      } else {
        self.isExistingUserMember(false);
      }
    },
    function(err) {
      var location = window.location.href || document.URL;
      APIHelper.post('/api/log/error', {
        message: 'API-error: add-employee-modal.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + err.responseText,
          'status: ' + err.status,
          'statusText: ' + err.statusText,
          'requestUrl: ' + url
        ]
      });
    }
  );
};

AddEmployeeModal.prototype.addSelectedUser = function() {
  var self = this;

  if (self.results().length > self.modalUsers()) {
    //get ready to post data
    var userAktorId = self.results()[self.modalUsers()].AktorId;
    var url =
      self.API.connectPersonToAgencyUrl +
      '?aktorIdPerson=' +
      userAktorId +
      '&aktorIdAgency=' +
      self.agencyAktorId;
    this.submitData(url, [], false);
  } else {
    //Show new form
    self.registerNewUser(true);
  }
};

AddEmployeeModal.prototype.formatData = function() {
  var self = this;
  var url = self.API.createUserUrl;
  this.requiredFields = [
    self.givenName,
    self.surname,
    self.mobileNumber,
    self.email
  ];
  if (!this.validateFields(this.requiredFields)) {
    return;
  }
  var data = {
    AgencyAktorId: self.agencyAktorId,
    FirstName: self.givenName(),
    LastName: self.surname(),
    Phone: self.mobileNumber(),
    Email: self.email()
  };

  self.submitData(url, data, false);
};

AddEmployeeModal.prototype.submitData = function(url, data, connectToAgency) {
  var self = this;
  self.isSubmitting(true);

  APIHelper.post(
    url,
    data,
    function(data) {
      if (connectToAgency && (data !== null && typeof data === 'object')) {
        var userAktorId = data.AktorId;
        var url =
          self.API.connectPersonToAgencyUrl +
          '?aktorIdPerson=' +
          userAktorId +
          '&aktorIdAgency=' +
          self.agencyAktorId;
        self.submitData(url, [], false);
      } else {
        self.hasUpdatedSuccessfully(true);
        self.isSubmitting(false);
        self.parent.getPageData();
      }
    },
    function(err) {
      self.isSubmitting(false);
      self.showErrorMessage(true);
      self.errorText(decodeHtml(err.statusText));
      var location = window.location.href || document.URL;
      APIHelper.post('/api/log/error', {
        message: 'API-error: add-employee-modal.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + err.responseText,
          'status: ' + err.status,
          'statusText: ' + err.statusText,
          'requestUrl: ' + url
        ]
      });
    }
  );
};

AddEmployeeModal.prototype.validateFields = function(fields) {
  var isValid = true;

  for (var i = 0; i < fields.length; i++) {
    if (fields[i]() === undefined || fields[i]() === null) {
      fields[i].hasError(true);
    }
    if (fields[i].hasError()) {
      isValid = false;
    }
  }
  return isValid;
};

AddEmployeeModal.prototype.closeModal = function() {
  this.activeModal(!this.activeModal());
  this.params.closeCallback();
};

AddEmployeeModal.prototype.hideSuccessMessage = function() {
  this.reset();
  this.searchMobileNumber('');
  this.searchEmail('');
  this.searchMobileNumber.hasError(false);
  this.searchEmail.hasError(false);
};

AddEmployeeModal.prototype.hideErrorMessage = function() {
  this.showErrorMessage(false);
};

AddEmployeeModal.prototype.reset = function() {
  var self = this;
  self.hasSearched(false);
  self.isSearching(false);
  self.isSubmitting(false);
  self.registerNewUser(false);
  self.showErrorMessage(false);
  self.hasUpdatedSuccessfully(false);
  self.isExistingUserMember(false);
};

module.exports = AddEmployeeModal;
